import config from 'config';

const DEV_ADDRESSES_URL = 'https://addresses.dev.bettertrucks.com';
const SANDBOX_ADDRESSES_URL = 'https://addresses.sandbox.bettertrucks.com';
const PROD_ADDRESSES_URL = 'https://addresses.bettertrucks.com';

/**
 * The addresses portal to use for the current environment. A trace id only exists in the
 * environment it was created in, so a dev trace id opened on the production report shows
 * an empty report.
 */
const getAddressesUrl = () => {
    const apiUrl = config.API_URL || '';

    if (apiUrl.includes('localhost') || apiUrl.includes('.dev.')) return DEV_ADDRESSES_URL;
    if (apiUrl.includes('.sandbox.')) return SANDBOX_ADDRESSES_URL;

    return PROD_ADDRESSES_URL;
};

export const getAddressReportUrl = (traceId: string) => {
    return `${getAddressesUrl()}/address-report-management/${traceId}`;
};
